var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "47px",
    viewBox: "0 0 50 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Loading/Wind") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.62219557%",
    y1: "6.57727231%",
    x2: "72.9278826%",
    y2: "76.1361924%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626263",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2F31",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-Data->-Loading-Widgets",
    transform: "translate(-998.000000, -800.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(804.000000, 656.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.598901,171.794674 L218.508852,178.015934 L223.265914,173.265015 C224.247679,172.283251 225.710885,172.006198 226.965653,172.51943 L227.425073,172.749105 L244,182.652 L244,190.594 L226.208852,179.961388 L221.411515,184.761779 C220.412078,185.761216 218.916461,186.028504 217.650641,185.48172 L217.080792,185.17095 L206.277034,178.384116 L194,182.031 L194,174.921 L205.815903,171.413729 C206.755208,171.134872 207.769085,171.273655 208.598901,171.794674 Z M209.196716,144.998524 L218.999761,154.802297 L223.265914,150.537742 C224.476217,149.32744 226.370143,149.217412 227.70474,150.20766 L228.087097,150.537742 L244,166.451 L244,176.093 L225.677034,157.770479 L221.411515,162.034506 C220.201213,163.244809 218.307287,163.354836 216.972689,162.364589 L216.589587,162.033761 L206.527034,151.975025 L194,161.957 L194,153.239 L204.661567,144.743003 C206.018139,143.661985 207.970158,143.771966 209.196716,144.998524 Z",
    id: "Loading/Wind"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "0.5s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpline);
export default __webpack_public_path__ + "static/media/icon-spline.b5ea89bffb53cf06d3a7f3ab50679081.svg";
export { ForwardRef as ReactComponent };